<template>
  <div
    class="h-screen overflow-hidden bg-cover bg-center"
    :data-theme="company?.cp_theme"
  >
    <div class="h-screen overflow-auto bg-gray-100">
      <navbar v-if="!customBranding" />
      <div
        class="container mx-auto pb-16"
        :class="{ 'pt-16': customBranding }"
      >
        <router-view></router-view>
        <v-footer></v-footer>
      </div>
    </div>
    <Alerts />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue"
import VFooter from "./components/VFooter.vue"

export default {
  name: "ClientAuthApp",

  components: {
    Navbar,
    VFooter,
  },

  data() {
    return {
      company: window.FinancialCents.company || null,
    }
  },

  computed: {
    customBranding() {
      if (!this.company) {
        return false
      }
      return this.company.custom_branding === true
    },
  },
}
</script>

<style scoped></style>
